module.exports = __webpack_public_path__ + "static/media/logo.174070d2.svg";